import { RouteRecordRaw } from 'vue-router'

declare module 'vue-router' {
  interface RouteMeta {
    title?: string,
    icon?(): Promise<any & { default: Comment }>,
    activeMenu?: string,
    role?: string[]
    permission?: string,
    isMenu?: boolean
  }
}

export type Module = { routes: RouteRecordRaw[], isMenu?: boolean }
export type Modules = Record<string, Module>

export const createModule = (routes: RouteRecordRaw[], isMenu = false): Module => { return { routes, isMenu } }
